export const handleEditExpense = async (expenseId, noteId, navigate) => {
  // Naviguer vers la page d'édition de dépense
  navigate(`/edit-expense/${noteId}/${expenseId}`);
};